module.exports = __webpack_public_path__ + "img/cultural-image.042979cc.png";